<template>
  <v-app id="app">

    <MoreDrawer />

    <v-content app>
      <router-view />
    </v-content>

<!--    <BottomNavigation v-if="$route.meta.depth !== true"/>-->

    <ImageViewer />
    <v-snackbar v-model="chromeInstallSnackbar" top :timeout="0" class="install-banner">
      <div class="pa-2" style="display: flex; align-items: center;">
        <div class="mr-2">
          <v-icon @click.stop="chromeInstallSnackbar = false" color="#eaeaea" size="16px">$vuetify.icons.cancel</v-icon>
        </div>
        <v-avatar tile class="mr-2">
          <img style="border-radius: 10px;" :src="`${$baseUrl}/static/icon/og-image.png`">
        </v-avatar>
        <div class="text-xs-left">
          <h3>유스</h3>
          <span class="caption">더 많은 유학 정보를 확인해보세요!</span>
        </div>
        <v-spacer></v-spacer>
        <div>
          <v-btn flat color="blue lighten-2" @click="installApp">열기</v-btn>
        </div>
      </div>
    </v-snackbar>

    <VisitDialog :isMobile="true" />
    <AlarmDialog :isMobile="true" />

  </v-app>
</template>

<script>
  import { mapActions } from 'vuex';
  import MoreDrawer from '@/components/MoreDrawer';
  // import BottomNavigation from '@/components/BottomNavigation';
  import ImageViewer from "@/components/ImageViewer";
  import VisitDialog from "@/components/VisitDialog";
  import AlarmDialog from "@/components/AlarmDialog";

  export default {
    components: { VisitDialog, AlarmDialog, ImageViewer, MoreDrawer },
    data () {
      return {
        chromeInstallSnackbar: false,
        deferredPrompt: null
      };
    },
    async created () {
      this.updateNow();
      const auth = window.localStorage.getItem('jwt');
      // console.log('created, user token: ', auth);
      if (typeof auth === 'string' && auth !== '') {
        await this.loginWithToken(auth).then(response => {
          this.setUser(response.data);
          this.setJWT(auth);
        }).catch(err => {
          console.error(err);
          this.setJWT('');
        });
      }

      if (this.$route.query.openVisitDialog === '1') {
        console.log('openVisitDialog');
        this.toggleVisitDialog(true);
      }

      if (this.$route.query.openAlarmDilog === '1') { // TODO: 오타 수정
        console.log('openAlarmDialog');
        this.toggleAlarmDialog(true);
      }

      this.openChromeInstallSnackbar();
    },
    methods: {
      ...mapActions([ 'updateNow', 'toggleVisitDialog', 'toggleAlarmDialog' ]),
      ...mapActions('user', [ 'setUser', 'setJWT', 'loginWithToken' ]),
      openChromeInstallSnackbar () {
        window.addEventListener('beforeinstallprompt', (e) => {
          // Prevent Chrome 67 and earlier from automatically showing the prompt
          e.preventDefault();
          // Stash the event so it can be triggered later.
          this.deferredPrompt = e;
          // Update UI notify the user they can add to home screen
          this.chromeInstallSnackbar = false;
        });
        // 브라우저로 접속한 경우 걍 띄움
        const isMobile = navigator.userAgent.indexOf('Mobi') > -1;
        const isiOS = navigator.userAgent.match(/ipad|iphone/i) !== null;
        if (!isiOS && isMobile && !(window.native || typeof webkit !== 'undefined')) {
          this.chromeInstallSnackbar = true;
        }
      },
      installApp (e) {
        // hide our user interface that shows our A2HS button
        this.chromeInstallSnackbar = false;
        // Show the prompt
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt();
          // Wait for the user to respond to the prompt
          this.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
            this.deferredPrompt = null;
          });
        } else {
          // window.location.href="youth://app";
          window.location.href="intent://#Intent;scheme=youth;package=com.glorang.youth;end";
        }
      }
    }
  };
</script>

<style lang="scss">
  body {
		background-color: #f4f3f7;
    //background-color: map_get($colors, background);
  }
  #app {
    font-family: 'Spoqa Han Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #4a4a4a;
		background-color: #f4f3f7;
    //background-color: map_get($colors, background);
		max-width: 950px;
		margin: 0 auto;
  }
  .install-banner .v-snack__content {
    display: block;
    padding: 0;
    height: auto;
  }
	// override for desktop
	.v-toolbar__content {
		height: 56px !important;
	}
	.v-toolbar--absolute, .v-toolbar--fixed {
		//left: unset !important;
		left: 50% !important;
		transform: translateX(-50%) !important;
	}
	.v-footer--absolute, .v-footer--fixed {
		left: unset !important;
	}
	nav {
		max-width: 950px;
		max-height: 56px;
	}
	footer {
		max-width: 950px;
	}
	.v-bottom-sheet.v-dialog {
		max-width: 950px;
		min-width: unset !important;
	}
</style>
